/**
 * AKLE — Carrito: cantidad +/-, sincronización de badge y compatibilidad ajaxCart
 */
(function () {
  'use strict';

  var AKLE_CART_SECTION = 'main-cart';
  var changeEvent = typeof Event === 'function' ? new Event('change', { bubbles: true }) : null;

  function ensureCartCountElement() {
    if (document.getElementById('cart-count')) return;

    var fallback = document.createElement('span');
    fallback.id = 'cart-count';
    fallback.className = 'visually-hidden';
    fallback.setAttribute('aria-hidden', 'true');
    fallback.textContent = '0';
    document.body.appendChild(fallback);
  }

  function patchCartFetch() {
    if (window.__akleCartFetchPatched || typeof window.fetch !== 'function') return;
    window.__akleCartFetchPatched = true;

    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (url, options) {
      var requestUrl = typeof url === 'string' ? url : (url && url.url ? url.url : '');

      if (requestUrl.indexOf('/cart/change') !== -1 && options && options.body) {
        try {
          var body = JSON.parse(options.body);
          if (body.sections) {
            var sections = String(body.sections)
              .split(',')
              .map(function (part) { return part.trim(); })
              .filter(function (part) {
                return part && part !== 'undefined';
              });

            if (sections.indexOf('side-cart') === -1) {
              sections.unshift('side-cart');
            }
            if (sections.indexOf(AKLE_CART_SECTION) === -1) {
              sections.push(AKLE_CART_SECTION);
            }

            body.sections = sections.join(',');
            options = Object.assign({}, options, { body: JSON.stringify(body) });
          }
        } catch (error) {
          /* noop */
        }
      }

      return nativeFetch(url, options);
    };
  }

  function getCartCount() {
    var el = document.querySelector('[data-totalqty]');
    if (!el) return null;
    return el.getAttribute('data-totalqty') || el.dataset.totalqty;
  }

  function syncCartBadges() {
    var count = getCartCount();
    if (count === null) return;

    ensureCartCountElement();

    var cartCount = document.getElementById('cart-count');
    if (cartCount) cartCount.textContent = count;

    document.querySelectorAll('.akle-header-pro__cart-count').forEach(function (badge) {
      badge.textContent = count;
    });
  }

  function clearProcessingStates(root) {
    (root || document).querySelectorAll('.akle-cart-item.processing').forEach(function (item) {
      item.classList.remove('processing');
    });
  }

  function clampQty(input, next) {
    var min = parseInt(input.getAttribute('min'), 10);
    var max = parseInt(input.getAttribute('max'), 10);
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var value = parseInt(next, 10);
    if (isNaN(value)) value = min || 1;
    if (!isNaN(min) && value < min) value = min;
    if (!isNaN(max) && value > max) value = max;
    if (step > 1) {
      value = Math.round(value / step) * step;
      if (!isNaN(min) && value < min) value = min;
    }
    return value;
  }

  function triggerQtyChange(input) {
    if (!input) return;
    if (changeEvent) {
      input.dispatchEvent(changeEvent);
      return;
    }
    var evt;
    try {
      evt = new Event('change', { bubbles: true });
    } catch (error) {
      evt = document.createEvent('HTMLEvents');
      evt.initEvent('change', true, false);
    }
    input.dispatchEvent(evt);
  }

  function applyQtyDelta(input, delta) {
    var current = parseInt(input.value, 10) || 0;
    var next = clampQty(input, current + delta);
    if (next === current) return;
    input.value = next;
    triggerQtyChange(input);
  }

  function handleQtyClick(event) {
    var decr = event.target.closest('[data-akle-qty-decr]');
    var incr = event.target.closest('[data-akle-qty-incr]');
    if (!decr && !incr) return;

    var wrap = (decr || incr).closest('[data-akle-cart-qty]');
    if (!wrap) return;

    var input = wrap.querySelector('.akle-cart-item__qty-input');
    if (!input || input.disabled) return;

    event.preventDefault();
    event.stopPropagation();
    applyQtyDelta(input, decr ? -1 : 1);
  }

  function handleRemoveClick(event) {
    var link = event.target.closest('.remove-from-cart-link');
    if (!link || !link.closest('.akle-cart-item')) return;
    link.closest('.akle-cart-item').classList.add('processing');
  }

  function bindProcessingStates(root) {
    (root || document).querySelectorAll('.akle-cart-item__qty-input.disable-on-change').forEach(function (input) {
      if (input.dataset.akleProcessingBound === 'true') return;
      input.dataset.akleProcessingBound = 'true';
    });
  }

  function initCartUx(root) {
    bindProcessingStates(root);
    clearProcessingStates(root);
    syncCartBadges();
  }

  function bindDelegation() {
    if (document.documentElement.dataset.akleCartDelegated === 'true') return;
    document.documentElement.dataset.akleCartDelegated = 'true';

    document.addEventListener('click', handleQtyClick, true);
    document.addEventListener('click', handleRemoveClick, true);
    document.addEventListener('click', handleContinueClick, true);
  }

  function handleContinueClick(event) {
    var link = event.target.closest('[data-akle-cart-continue]');
    if (!link) return;

    event.preventDefault();

    var closeBtn = document.querySelector('#cart .akle-cart-drawer__close.m6pn-close');
    if (closeBtn) {
      closeBtn.click();
      return;
    }

    if (typeof window.hidePanels === 'function') {
      window.hidePanels();
    }
  }

  ensureCartCountElement();
  patchCartFetch();
  bindDelegation();

  document.addEventListener('DOMContentLoaded', function () {
    ensureCartCountElement();
    initCartUx(document);
  });

  window.addEventListener('listCart', function () {
    initCartUx(document.getElementById('cart') || document.querySelector('[data-akle-cart-page]') || document);
    syncCartBadges();
  });

  window.addEventListener('ajaxCart', function () {
    setTimeout(function () {
      initCartUx(document.getElementById('cart') || document.querySelector('[data-akle-cart-page]') || document);
      syncCartBadges();
    }, 60);
  });

  document.addEventListener('akle:cart-content-updated', function () {
    setTimeout(function () {
      initCartUx(document.getElementById('cart') || document.querySelector('[data-akle-cart-page]') || document);
      syncCartBadges();
    }, 60);
  });

  var cartPanel = document.getElementById('cart');
  if (cartPanel && typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function () {
      initCartUx(cartPanel);
      syncCartBadges();
    });
    observer.observe(cartPanel, { childList: true, subtree: true });
  }

  window.AkleCart = {
    syncBadges: syncCartBadges,
    refresh: initCartUx
  };
})();
